module.exports = __webpack_public_path__ + "static/media/greenbricksLogo.e122d43b.png";